
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const dne500: IProductData = {
  id: "hazelriggindustries-dne",
  name: "Hazelrigg Industries DNE",
  description: "DNE Pulse Width Modulation Compressor",
  specialOrder: true,
  images: ["/img/hazelriggindustries_dne_front.jpg", "/img/hazelriggindustries_dne_side.jpg"],
  details: [{
    label: "Description",
    markdown: `
The DNE gets its compression circuitry directly from the Hazelrigg Industries VNE and D.W. Fearn VT-7. Attack and release times have been optimized to simplify the user interface.  
The High Pass Filter (HPF) makes the compressor less reactive to low frequencies (for example, bass and kick).  
Linking units require 500 series racks with a link option.  
Signal path utilizes input and output transformers and low-THD/high-gain solid state devices. Gain reduction is shown with LEDs.  

User tips: The PWM methodology is capable of extremely fast attack and release times.  
When compressing bass-oriented instruments, it is possible to have audio artifacts when the release is set too fast.  
This is usually not an issue on program material.  

When linking units, attack and release times will be averaged.  
Units do not have to be set exactly the same.  
However, keep in mind that if the threshold is not turned up on a DNE, the side chain won’t reference the audio passing through the unit, even though it may be compressing it if linked.  
`
  }, {
    label: "Features",
    markdown: `
- PWM Circuit Identical to VT-7 / VNE
- Linkable for Stereo Operation
- Streamlined Interface for Fast, Intuitive Control
- 7 Year Warranty
- Transformers in Both Input and Output Stages
- Attach Time Selector Switch–Fast/Slow
- Release Time Selector Switch–Fast/Slow
- Threshold Control
- Output Indicator LED
- LED Gain Reduction Meter
- High Pass Filter Switch
- Link Switch
- Makeup Gain Control
- Bypass Switch
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/hazelriggdseries" target="_blank">https://www.hazelriggindustries.com/hazelriggdseries</a>
- <a to="https://static1.squarespace.com/static/610da5f698ae9050ada60fb8/t/670524bc3dbf934c5a519711/1728390332954/D+series+manuals.pdf" target="_blank">Manual</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.API_500, HASHTAGS.SINGLE_SLOT, HASHTAGS.COMPRESSOR],
    manufacturer: BRAND.HAZELRIGG,
  }
}